import axios from "axios"
import get from "lodash/get"
import URITemplate from "urijs/src/URITemplate"
import {
  GET_SERVICE_CHANGE_PRICE_INFO_FAILED,
  GET_SERVICE_CHANGE_PRICE_INFO_FULFILLED,
  GET_SERVICE_CHANGE_PRICE_INFO_PENDING,
} from "constants-lib/actionTypes"
import { getTokenAction } from "actions-lib/getToken"
import { urls } from "utils-lib/builds"
import { MOCK_SERVICE_CHANGE_INFORMATION } from "utils-lib/mocks"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

export const pendingPriceDiffAC = () => ({
  type: GET_SERVICE_CHANGE_PRICE_INFO_PENDING,
})

export const failedPriceDiffAC = () => ({
  type: GET_SERVICE_CHANGE_PRICE_INFO_FAILED,
})

export const fulfilledPriceDiffAC = (data) => ({
  type: GET_SERVICE_CHANGE_PRICE_INFO_FULFILLED,
  payload: data,
})

export const getServiceChangePriceInfo =
  (customerId, payload) => (dispatch, getState) => {
    const api = `SERVICE_CHANGE_PRICE`
    const template = URITemplate(urls.url[api])
    const state = getState()
    const locale = get(state, `siteLanguage.language`, ``)

    const mockJsonFile = `${ssrWindow.origin}/mock/get-pricing-difference-response.json`

    const url = MOCK_SERVICE_CHANGE_INFORMATION
      ? mockJsonFile
      : template.expand({
          customerId,
          userId: get(state, `userAccount.userDetails.userId`, ``),
          lang: locale,
        })

    const data = {
      ...payload,
    }

    const config = {
      method: `POST`,
      headers: {},
      data,
    }

    return getTokenAction(dispatch, getState).then(async (res) => {
      config.headers.oktaToken = res.accessToken
      config.headers.apiKey = get(urls, `apiKey.USER[${api}]`, ``)

      return getServiceChangePriceInfoHelper(url, config, dispatch, data)
    })
  }

export const getServiceChangePriceInfoHelper = (
  url,
  config,
  dispatch,
  data,
) => {
  dispatch(pendingPriceDiffAC())

  return axios
    .create(config)
    .post(url, data)
    .then((response) => {
      dispatch(fulfilledPriceDiffAC(get(response, `data.data`, {})))
      return response.data
    })
    .catch((error) => {
      dispatch(failedPriceDiffAC())
      return error
    })
}
